<template src="./templates/index.html" />
<script type="text/ecmascript-6">
import FouGrid from 'src/components/layout/fou-grid/'
import FouContainer from 'components/tools/fou-container/'
import Methods from 'src/pages/contract/script/common.methods'
import EyeIcon from 'components/icons/eye/'
import EyeSlashIcon from 'components/icons/eye-slash/'
import FouSelect from 'components/form/fou-select/'
import FouDropdown from 'components/form/fou-dropdown/'
import FouGroup from 'src/components/layout/fou-group/'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import AnimationProcessing from 'components/animations/processing'
import TextField from 'components/form/text-field/index.vue'
import VSelect from 'components/form/v-select/index.vue'
import TextEditor from 'components/form/text-editor/index.vue'
import AiTextEditor from 'components/form/ai-text-editor/index.vue'
import TextArea from 'components/form/text-area/index.vue'
import Errors from 'src/utils/helper/errors'
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import FouAccordion from 'components/tools/fou-accordion/'
import FouAccordionItem from 'components/tools/fou-accordion/item'
import OkIcon from 'components/icons/ok/'
import Modal from 'src/components/form/fou-dialog/index.vue'
import { Toaster } from 'src/utils/helper/toaster'
import misc, { createImagePreSignedURL } from 'src/utils/helper/misc'
import WellDoneFoundry from 'src/components/general/common-popup/index.vue'
import { MdTypography, MdButton, MdIconFavoriteSolid, MdLink, MdIconArrowLong } from '@antiqua-dls/vue-components'
import commonPopup from 'components/general/common-popup/index.vue'
import {
  AI_SUGGESTION_ASSET_TYPES,
  DESCRIPTION_CHAR_LIMITS
 } from 'src/utils/constants/common'
 import i18n from 'src/assets/i18n/i18n';
 import FouEmailVerify from 'components/general/fou-email-verify';

import InfoIcon from '../new-foundry/assets/info-svg.vue'
import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import OverlayInfo from './OverlayInfo/index.vue'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES } from '../../../../../../modules/adobe-cja/constants'
import ImageUploader from './ImageUploader'
import ProgressBar from './progress-bar.vue'
import Uploader from './uploader-img.vue'

const { t } = i18n().global;

export default {
  name: 'NewFoundry',
  components: {
    ...FouGrid,
    FouContainer,
    FouEmailVerify,
    FouSelect,
    FouDropdown,
    FouSelectObject,
    AnimationProcessing,
    FouGroup,
    EyeIcon,
    EyeSlashIcon,
    Uploader,
    ProgressBar,
    TextField,
    VSelect,
    TextEditor,
    AiTextEditor,
    TextArea,
    FouAccordion,
    FouAccordionItem,
    OkIcon,
    Modal,
    ImageUploader,
    InfoIcon,
    OverlayInfo,
    WellDoneFoundry,
    commonPopup,
    MdTypography,
    MdButton,
    MdIconFavoriteSolid,
    MdLink,
    MdIconArrowLong
  },

  data() {
    return {
      aiTextEditorConfig: {
        aiEnabled: true,
        placeholder: {
          ai_disabled: t('pages.aiTextEditor.placeholder_foundry', { moduleName: 'foundry' }),
          ai_enabled: t('pages.aiTextEditor.ai_enabled_placeholder', { moduleName: 'foundry' })
        },
        aiActions: {
          boostVisibility: true,
          polishWriting: true,
          fixGrammar: true,
          shortenText: true,
        },
        assetType: AI_SUGGESTION_ASSET_TYPES.foundry,
        assetId: this.$route.params.id,
        charLimits: DESCRIPTION_CHAR_LIMITS
      },
      arrowLink: "require('../assets/arrow-link.png')",
      backendValue: '',
      backendStateValue:'',
      backendAddressCountryValue: '',
      backendAddressStateValue: '',
      customPlaceholder: 'Country of foundry',
      customStatePlaceholder: 'Select city/state',
      selectedCountry: {},
      selectedState: {},
      selectedHeadOfficeCountry: {},
      selectedHeadOfficeState: {},
      options: {
        bounds: '.mt-wrapper',
      },
      spinner: true,
      warningWordForCity: false,
      warningWords: [],
      isPopUp: false,
      emailConsentPopup: false,
      bannerEditable: false,
      country: FouSelectObject(),
      states: FouSelectObject(),
      headOfficeCountries: FouSelectObject(),
      headOfficeStates: FouSelectObject(),
      showStates: false,
      showAddressStates : false,
      foundry: {
        name: '',
        id: '',
        externalId: '',
        foundryDescription: '',
        shortDescription: '',
        supportEmail: {
          contactName: '',
          emailAddress: ''
        },
        licensingEmail: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          country: '',
          headOfficeCountry: '',
          headOfficeState: '',
          state: '',
          zipCode: '',
          telephone: '',
          website: '',
          addressIsPublic: 'No',
          // country: FouSelectObject(),
          // states: FouSelectObject(),
        },
        womenOwned: '',
        bipocOwned: '',
        lgbtqOwned: '',
        images: [],
        emailConsent: '',
      },
      imgBanner: '',
      imgLogo: '',
      imageID: '',
      errors: {},
      deiQuestionsArr: [
        {
          id: 0,
          ques: 'Is your foundry a women-owned business?',
          selectedOption: ''
        },
        {
          id: 1,
          ques: 'Is your foundry a BIPOC-owned business?',
          selectedOption: ''
        },
        {
          id: 2,
          ques: 'Is your foundry a LGBTQ+-owned business?',
          selectedOption: ''
        }
      ],
      isDeiError: false,
      isEditable: false,
      imageLogoID: '',
      imageBannerID: '',
      isBannerImgUploadStart: false,
      BannerProgressPerc: 0,
      isLogoImgUploadStart: false,
      LogoProgressPerc: 0,
      closePopUpModal: false,
      deleteOption: '',
      logoError: '',
      bannerError: '',
      updatedCountry: '',
      isEdit: false,
      foundryStatus: {
        imagerySectionStatus: false,
        InformationSectionStatus: false,
        DiversitySectionStatus: false,
        ContactInfoSectionStatus: false
      },
      activeSection: 'FoundryImagery',
      foundryCompletenessPerc: 0,
      disabledBtn: false,
      emailConsentChecked: false,
      imageProcessingLogo: false,
      imageProcessingBanner: false,
      logoImageChanged: false,
      showOverlayInfo: false,
      overlaySec: '',
      alreadyUploadedMd5: [],
      showWellDonePopup: false,
      showGreatJobPopup: false,
      nextChallengeRoute: '',
      previousHealthPercentage: 0,
      showPermissionNeededPopup: false,
      descriptionError: false,
      avStatusPollingInterval: null,
      avStatusPollingId: null,
    }
  },

  watch: {
    foundry: {
      handler(e) {
        if (e.images?.length === 2) {
          this.foundryStatus.imagerySectionStatus = true
        } else {
          this.foundryStatus.imagerySectionStatus = false
        }
        const htmlDescriptionString = e.foundryDescription && e.foundryDescription[0]?.description?.trim();
        const modifiedDescriptionHtmlString = htmlDescriptionString?.replace(/<p>|<\/p>/g, '') || '';
        if (modifiedDescriptionHtmlString.trim() && e.address.headOfficeCountry?.trim() && (!this.showStates || e.address.headOfficeState?.trim())) {
          this.foundryStatus.InformationSectionStatus = true
        } else {
          this.foundryStatus.InformationSectionStatus = false
        }
        let flag = ''
        if (e.supportEmail?.contactName.trim() && e.supportEmail?.emailAddress.trim() && (e.address.country?.trim() && (!this.showAddressStates || e.address.state?.trim())) && e.address?.address1.trim() && e.address?.city.trim() && e.address?.zipCode.trim()) {
          flag = true
        } else {
          flag = false
        }
        if (flag) {
          this.foundryStatus.ContactInfoSectionStatus = true
        } else {
          this.foundryStatus.ContactInfoSectionStatus = false
        }

        this.applyDisabled(e)
        this.ProfileCompletenessPerc()
      },
      deep: true
    },
    deiQuestionsArr: {
      handler(e) {
        if (this.deiQuestionsArr[0].selectedOption !== '' && this.deiQuestionsArr[1].selectedOption !== '' && this.deiQuestionsArr[2].selectedOption !== '' && !this.isDeiError) {
          this.foundryStatus.DiversitySectionStatus = true
        } else {
          this.foundryStatus.DiversitySectionStatus = false
        }
        this.ProfileCompletenessPerc()
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch('profile/getFoundries', 'foundry-profile').then(() => {
      this.setData()
    })
    this.$events.$on('closePopUp', () => {
      this.canclePopUp()
    })
    window.addEventListener('resize', this.resizeBanner)
    window.scrollTo(0, 0)
    this.$events.$on('closeOtherItems', (currentItem) => {
      this.closeOtherItems(currentItem)
    })
    this.getFoundryHealthChallenges()
  },
  updated() {
    if (window.innerWidth < 743 && document.getElementById('withoutBannerImg') && document.getElementById('imgUploadWithoutBanner')) {
      document.getElementById('imgUploadWithoutBanner').style.bottom = 0
    }
  },
  beforeUnmount() {
    this.$events.$off('closePopUp')
    this.$events.$off('DeletePopUp')
    this.stopAvStatusPolling()
  },
  onUnmounted() {
    window.removeEventListener('resize', this.resizeBanner)
    this.stopAvStatusPolling()
  },
  computed: {
    ifImpersonate() {
      return JSON.parse(window.localStorage.getItem('FS-Impersonate'))
    },
    getRules() {
      return {
        'foundry short description': 'custom_max_char_no_html:600',
        'headOfficeCountry': 'required|script_tag_validate',
        'headOfficeState': 'required|script_tag_validate',
        'foundry description': 'custom'
      };
    },
    ...mapGetters('foundrySupport', ['getAvScanStatus']),
    isSomethingRemoved() {
      if(this.foundryCompletenessPerc < this.previousHealthPercentage){
        this.previousHealthPercentage = this.foundryCompletenessPerc;
        return true
      }
      return false
    },
    popupDescriptionText() {
      if(this.isSomethingRemoved){
        return this.$t('pages.profile.foundry_profile.well_done_popup.somethingRemovedDesc');
      }
      if (this.nextChallengeRoute === 'post_contract') {
        if (this.ufdaStatus === 'UFDA') {
          return this.$t('pages.profile.foundry_profile.well_done_popup.agreement_description_ufda1');
        }
        return this.$t('pages.profile.foundry_profile.well_done_popup.agreement_description_non_ufda');
      }
      return this.$t('pages.profile.foundry_profile.well_done_popup.description');
    }
  },
  methods: {
    ...mapActions('overlay', ['hide', 'show']),
    ...Methods,

    getSectionVariant(sectionName) {
      return this.activeSection === sectionName ? 'body1--bold' : 'body1--regular'
    },

    handleErrorStatus(status) {
      this.descriptionError = status;
    },

    getSectionColor(sectionName, sectionStatus) {
      const isActive = this.activeSection === sectionName
      if (sectionStatus) {
        return isActive ? 'turtle-green--500' : 'turtle-green--700'
      }
      return isActive ? 'spirits--800' : 'spirits--700'
    },

    getSectionClass(sectionName, sectionStatus) {
      const isActive = this.activeSection === sectionName
      return [
        this.$style.foundryProfileAccordianItemtitle,
        sectionStatus ? this.$style.isFoundryProfileComplete : this.$style.isFoundryProfileIncomplete,
        { [this.$style.clickedSection]: isActive }
      ]
    },

    applyDisabled(e) {
      this.disabledBtn = e.address?.headOfficeCountry?.trim() && (!this.showStates || e.address?.headOfficeState?.trim()) && e.address?.country?.trim() && (!this.showAddressStates || e.address?.state?.trim()) && e.foundryDescription[0]?.description?.trim() && e.supportEmail?.contactName?.trim() && e.supportEmail?.emailAddress?.trim() && e.address?.address1?.trim() && e.address?.city?.trim() && e.address?.zipCode?.trim()
    },

    imageUploadDetails(detail) {
      this.imageUploadHandle(detail)
    },

    imageDelete(option) {
      this.deletePopUp(option)
      this.logoImageChanged = true
    },
    setData() {
      this.spinner = true
      return new Promise((resolve) => {
        this.$store.dispatch('foundrySupport/getFoundryById', { foundryId: this.$route.params.id })
          .then((response) => {
            this.foundry = { ...response }
            this.setDeiCheckBoxFromApi()
            this.setCountries()
            this.city = response.address.city
            this.setImage(response.images)
            this.spinner = false
            this.selectedCountry = this.country.values
            this.backendAddressCountryValue =  response.address.country
            this.backendAddressStateValue = response.address.state
            this.selectedHeadOfficeCountry = this.headOfficeCountries.values
            this.selectedState = this.states.values
            this.selectedHeadOfficeState = this.headOfficeStates.values
            this.bannerError = ''
            this.logoError = ''
            this.isEditable = false
            this.foundry.emailConsent = response.emailConsent
            this.ufdaStatus = response.contractSummary
            if (response.emailConsent === 'Yes') {
              this.emailConsentChecked = true
            } else {
              this.emailConsentChecked = false
            }
            this.isDeiError = false
            this.backendValue = response.address.headOfficeCountry
            this.clearPrevImageObj()
            const selectedCountry = this.country.options.find((x) => x.value == this.backendValue)
            if(selectedCountry){
              this.setStates(selectedCountry);
            }
            if(this.backendValue && response.address.headOfficeState){
              this.backendStateValue = this.backendValue + '-' + response.address.headOfficeState
            }
            const selectedAddressCountry = this.country.options.find((x)=>x.value == this.backendAddressCountryValue)
            if(selectedAddressCountry){
              this.setHeadofficeStates(selectedAddressCountry);
            }
            if(this.backendAddressCountryValue && response.address.state){
              this.backendAddressStateValue = this.backendAddressCountryValue + '-' + response.address.state
            }
            resolve()
          }).catch(() => {
            this.spinner = false
          })
      })
    },

    editable() {
      this.isEditable = !this.isEditable
      this.bannerEditable = false
    },

    handleSelectAction(option){
      this.backendValue = option.value
      this.foundry.address.headOfficeCountry = option.value
      this.backendStateValue = '';
      this.foundry.address.headOfficeState = '';
      this.setStates(option)
    },

    handleStateSelectAction(option){
      this.backendStateValue = option.value
      this.foundry.address.headOfficeState = option.value.split('-')[1];
    },

    handleAddressStateSelectAction(option){
      let obj = {...option}
      this.backendAddressStateValue = option.value
      this.states.update(obj)
      this.foundry.address.state = obj.value.split('-')[1];
    },

    clearPrevImageObj () {
      if (!this.imageLogoID) window.localStorage.removeItem('prevImageLogoObj')
      if (!this.imageBannerID) window.localStorage.removeItem('prevImageBannerObj')
    },
    // Popup
    deletePopUp(option) {
      this.isEditable = false
      this.bannerEditable = false
      this.$store.commit('profile/setFoundryModal')
      if (option === 'deleteLogo') {
        this.isPopUp = true
        this.closePopUpModal = true
        this.isEditable = false
        this.imageID = this.imageLogoID
        this.deleteOption = 'deleteLogo'
      } else if (option === 'deleteBanner') {
        this.isPopUp = true
        this.closePopUpModal = true
        this.bannerEditable = false
        this.imageID = this.imageBannerID
        this.deleteOption = 'deleteBanner'
      }
    },

    canclePopUp() {
      this.isPopUp = false
    },

    closePopUp() {
      this.closePopUpModal = false
      this.isPopUp = false
      this.hide()
    },

    closeWellDonePopUp() {
      this.showWellDonePopup = false
    },

    closeGreatJobPopUp() {
      this.showGreatJobPopup = false
    },

    bannerDropDown() {
      this.bannerEditable = !this.bannerEditable
      this.isEditable = false
    },

    setImage(images) {
      this.images = images
      if (this.images.length > 0) {
        if (this.images.length === 1 && this.images[0].priority === 1) {
          this.imgBanner = ''
          this.imageBannerID = ''
        }
        if (this.images.length === 1 && this.images[0].priority === 2) {
          this.imgLogo = ''
          this.imageLogoID = ''
        }
        this.images.map((item) => {
          if (item.priority === 1) {
            this.imgLogo = item.resourceLocation
            this.imageLogoID = item.id
            const imageObj = {
              imageId: item.id, priority: item.priority, foundryId: this.foundry.id, loc: item.resourceLocation
            }
            window.localStorage.setItem('prevImageLogoObj', JSON.stringify(imageObj))
          } else if (item.priority === 2) {
            this.imgBanner = item.resourceLocation
            this.imageBannerID = item.id
            const imageObj = {
              imageId: item.id, priority: item.priority, foundryId: this.foundry.id, loc: item.resourceLocation
            }
            window.localStorage.setItem('prevImageBannerObj', JSON.stringify(imageObj))
          }
        })
      } else {
        this.imgLogo = ''
        this.imageLogoID = ''
        this.imgBanner = ''
        this.imageBannerID = ''
      }
    },

    //DicardFOundry
    discardFoundry() {
      this.clearPrevImageObj()
      window.location.reload()
      this.descriptionError = false;
    },

    // Delete API
    deleteImage() {
      this.closePopUpModal = false
      this.isPopUp = false
      this.hide()
      const id = this.imageID
      const foundryID = this.foundry.id
      const option = {
        foundryId: foundryID,
        logoId: id
      }
      if (this.imageLogoID) {
        window.localStorage.removeItem('prevImageLogoObj')
      }
      if (this.imageBannerID) {
        window.localStorage.removeItem('prevImageBannerObj')
      }
      this.$store.dispatch('foundrySupport/deleteImageProfile', option)
        .then((res) => {
          if (res.success === true) {
            this.$store.commit('foundrySupport/setAvScanStatus', {status: '', name: ''})
            if (option.logoId === this.imageLogoID) {
              this.imgLogo = ''
              this.foundry.images = this.foundry.images.filter(e => e.priority !== 1)
              this.logoError = ''
              this.$forceUpdate()
            } else if (option.logoId === this.imageBannerID) {
              this.imgBanner = ''
              this.bannerError = ''
              this.foundry.images = this.foundry.images.filter(e => e.priority !== 2)
              this.$forceUpdate()
            }
          }
        })
    },

    setDeiCheckBoxFromApi() {
      this.deiQuestionsArr[0].selectedOption = this.foundry.womenOwned
      this.deiQuestionsArr[1].selectedOption = this.foundry.bipocOwned
      this.deiQuestionsArr[2].selectedOption = this.foundry.lgbtqOwned
    },
    setDeiCheckbox(e, quesId) {
      if (this.isDeiError) { this.isDeiError = false }
      this.deiQuestionsArr[quesId].selectedOption = e.target.checked ? e.target.name : ''
    },

      toggleEmailConsent() {
        if (this.emailConsentChecked) {
          this.emailConsentPopup = true
          const emailCheck = document.getElementById('emailCheck')
          if (emailCheck) {
            emailCheck.checked = true
          }
        } else {
          this.foundry.emailConsent = 'Yes'
          this.emailConsentChecked = true
        }
      },
      unsubscribeEmailConsent() {
        this.emailConsentPopup = false
        this.foundry.emailConsent = ''
        this.emailConsentChecked = false
      },

    closeUnsubscribeModal() {
      this.emailConsentPopup = false
    },
    setStates (option) {
      this.states.update(null)
      this.backendStateValue = '';
      if (this.hasStates(option.value)) {
        this.showStates = true
        this.states.setOptions({
          obj: this.getStates(option.value),
          value: 'value',
          name: 'name',
          multiple: true
        })
      } else {
        this.showStates = false
      }
    },

    setHeadofficeStates(isoCountry) {
      this.headOfficeStates.update(null)
      this.states.update({
        ...this.states,
        values: null
      });
      if (this.hasStates(isoCountry.value)) {
        this.showAddressStates = true
        this.headOfficeStates.setOptions({
          obj: this.getStates(isoCountry.value),
          value: 'value',
          name: 'name',
          multiple: true
        })
      } else {
        this.showAddressStates = false
      }
    },

    saveFoundry () {
      const analyticsPayload = {
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.EDIT_PROFILE,
          linkSection: LINK_SECTION.FOUNDRY_INFO,
          linkName: `${LINK_NAMES.SAVE_CHANGES} ${this.foundry.name}`,
          linkType: LINK_TYPES.BUTTON
        }
      }
      adobeCjaEventEmitter(analyticsPayload)
      const options = {
        foundryId: this.$route.params.id,
        foundryDetail: {
          ...this.foundry,
          womenOwned: this.deiQuestionsArr[0].selectedOption,
          bipocOwned: this.deiQuestionsArr[1].selectedOption,
          lgbtqOwned: this.deiQuestionsArr[2].selectedOption
        }
      }
      this.$store.dispatch('foundrySupport/updateFoundryById', options)
        .then((res) => {
          if (res?.response && res?.status && res.status > 399 && res.status < 599) {
            Toaster.notifyError(res.response.data?.error?.message)
            return false
          } else if (res.status === 200) {
            if (res.data.emailConsent === "") {
              this.foundry.emailConsent = ''
              this.emailConsentChecked = false
            } else {
              this.foundry.emailConsent = 'Yes'
              this.emailConsentChecked = true
            }
            this.$store.commit('foundrySupport/setIsSuccess')
            this.showToasterOnImageUpdate()

            if (this.foundryCompletenessPerc === 100) {
              misc.updateChallengeData("edit_foundry", 'completed');
              misc.updateChallengeData("edit_foundry", 'completed');
              misc.updateChallengeData("edit_foundry", 'completed');
            }
            else {
              misc.updateChallengeData("edit_foundry", 'inComplete');
              }
            this.showWellDonePopup = true;
          }
        })
    },
    updateAddressCountryValue (location) {
      this.foundry.address.state = ''
      if (location) {
        this.country.state = 'set'
        this.backendAddressCountryValue = location.value;
        this.backendAddressStateValue = ''
        this.selectedCountry = location
        this.foundry.address.country = location.value
        this.country.update({ ...location })
      } else {
        this.foundry.address.country = ''
      }
      this.setHeadofficeStates(location)
    },

    updateHeadOfficeCountryValue(location) {
      this.foundry.address.headOfficeState = ''
      if (location) {
        this.headOfficeCountries.state = 'set'
        this.selectedHeadOfficeCountry = location
        this.foundry.address.headOfficeCountry = location.value
        this.headOfficeCountries.update({ ...location })
      } else {
        this.foundry.address.headOfficeCountry = ''
      }
      this.setHeadofficeStates(location)
    },

    updateStateValue(stateLoc) {
      if (!this.foundry) this.foundry = {};
      if (!this.foundry.address) this.foundry.address = {};
      if (stateLoc) {
        this.selectedState = stateLoc

        if (stateLoc.value) {
          this.foundry.address.state = stateLoc.value.split('-').pop()
        } else {
          this.foundry.address.state = ''
        }
        this.states.update({ ...stateLoc })
      } else {
        this.foundry.address.state = ''
      }
    },

    updateheadOfficeStateValue(stateLoc) {
      if (stateLoc) {
        this.selectedHeadOfficeState = stateLoc

        if (stateLoc.value) {
          this.foundry.address.headOfficeState = stateLoc.value.split('-').pop()
        } else {
          this.foundry.address.headOfficeState = ''
        }
        this.headOfficeStates.update({ ...stateLoc })
      } else {
        this.foundry.address.headOfficeState = ''
      }
    },

    hasStates(countryIso) {
      return countryIso !== null && (countryIso === 'AU' || countryIso === 'US' || countryIso === 'CA')
    },

    setImageLoc(priority) {
      if (priority === 1) {
        if (window.localStorage.getItem('prevImageLogoObj')) {
          const prevImageObj = JSON.parse(window.localStorage.getItem('prevImageLogoObj'))
          this.imgLogo = prevImageObj.loc
        }
      }

      if (priority === 2) {
        if (window.localStorage.getItem('prevImageBannerObj')) {
          const prevImageObj = JSON.parse(window.localStorage.getItem('prevImageBannerObj'))
          this.imgBanner = prevImageObj.loc
        }
      }
    },

    closeOverlayInfo() {
      this.showOverlayInfo = false
    },

    showOverlayInfoFunc(sec) {
      this.showOverlayInfo = true
      this.overlaySec = sec
    },

    stopAvStatusPolling() {
      if (this.avStatusPollingInterval) {
        clearInterval(this.avStatusPollingInterval);
        this.avStatusPollingInterval = null;
        this.avStatusPollingId = null;
      }
    },

    checkAvStatusofImage(id) {
      // Stop any existing polling
      this.stopAvStatusPolling();

      // Store the ID for polling
      this.avStatusPollingId = id;

      // Polling interval in milliseconds (5 seconds)
      const POLLING_INTERVAL = 5000;

      return new Promise((resolve, reject) => {
        let isResolved = false;

        const poll = async () => {
          // Don't poll if already resolved or if ID changed
          if (isResolved || this.avStatusPollingId !== id) {
            return;
          }

          try {
            const res = await this.$store.dispatch('foundrySupport/checkAvStatus', id);
            const hasEmptyAvStatus = res.data.assets.some(asset => asset.avStatus === '');
            const hasFalseAvStatus = res.data.assets.some(asset => asset.avStatus === 'false');
            const hasTrueAvStatus = res.data.assets.some(asset => asset.avStatus === 'true');
            if (hasFalseAvStatus) {
              this.$store.commit('foundrySupport/setAvScanStatus', { status: false, name: res.data.assets.find(asset => asset.avStatus === 'false').fileName});
            } else if (hasTrueAvStatus) {
              this.$store.commit('foundrySupport/setAvScanStatus', { status: true });
            } 
            
            if (!hasEmptyAvStatus) {
              // Status is no longer empty, stop polling and resolve
              isResolved = true;
              this.stopAvStatusPolling();
              resolve(res.data.assets);
            }
            // If status is still empty, continue polling (interval will call this again)
          } catch (error) {
            // Stop polling on error
            isResolved = true;
            this.stopAvStatusPolling();
            reject(error);
          }
        };

        // Initial call
        poll();

        // Set up interval for subsequent calls
        this.avStatusPollingInterval = setInterval(() => {
          // Only continue polling if we're still polling the same ID and not resolved
          if (this.avStatusPollingId === id && !isResolved) {
            poll();
          } else {
            // ID changed or resolved, stop this polling
            this.stopAvStatusPolling();
          }
        }, POLLING_INTERVAL);
      });
    },

    imageUploadHandle(e) {
      this.logoImageChanged = true
      if (e.priority === 1) {
        this.imageProcessingLogo = true
        this.imgLogo = ''
        setTimeout(() => {
          this.LogoProgressPerc = 75
        }, 1000)
      } else if (e.priority === 2) {
        this.imageProcessingBanner = true
        this.imgBanner = ''
        setTimeout(() => {
          this.BannerProgressPerc = 75
        }, 1000)
      }
      this.isEditable = false
      this.bannerEditable = false
      createImagePreSignedURL([e], this.alreadyUploadedMd5, 'foundry')
        .then((res) => {
          this.$store.dispatch('foundrySupport/UploadFoundryImage', res)
            .then(async (result) => {
              let data = await this.checkAvStatusofImage(result.relationId)
              for (res of data) {
                if (res.avStatus == 'false') {
                  const option = {
                      foundryId: res.relationId,
                      logoId: res.id
                  }
                  this.$store.dispatch('foundrySupport/deleteImageProfile', option)
                  this.imageProcessingBanner = false
                  this.imageProcessingLogo = false
                  this.imageProcessing = false
                  return;
                }
                // NOTE: also need to delete the last uploaded file
                // this.alreadyUploadedMd5.push(res.md5Checksum)
                if (res.priority === 1) {
                  this.imageProcessingLogo = false
                  this.LogoProgressPerc = 0
                  this.imgLogo = res.resourceLocation
                  this.imageLogoID = res.id
                  const imageObj = {
                    imageId: res.id, priority: res.priority, foundryId: this.foundry.id, loc: res.resourceLocation
                  }
                  window.localStorage.setItem('prevImageLogoObj', JSON.stringify(imageObj))
                  this.isLogoImgUploadStart = false
                  this.logoError = ''
                  this.foundry.images = this.foundry.images.filter(e => e.priority !== 1)
                  this.foundry.images.push(res)
                  this.$forceUpdate()
                } else if (res.priority === 2) {
                  this.imageProcessingBanner = false
                  this.BannerProgressPerc = 0
                  this.imgBanner = res.resourceLocation
                  this.imageBannerID = res.id
                  const imageObj = {
                    imageId: res.id, priority: res.priority, foundryId: this.foundry.id, loc: res.resourceLocation
                  }
                  window.localStorage.setItem('prevImageBannerObj', JSON.stringify(imageObj))
                  this.isBannerImgUploadStart = false
                  this.bannerError = ''
                  this.foundry.images = this.foundry.images.filter(e => e.priority !== 2)
                  this.foundry.images.push(res)
                  // this.$forceUpdate()
                } else if (res.errorKey) {
                  if (e.priority === 1) {
                    if (window.localStorage.getItem('prevImageLogoObj')) {
                      const prevImageObj = JSON.parse(window.localStorage.getItem('prevImageLogoObj'))
                      this.imgLogo = prevImageObj.loc
                    }
                    this.logoError = res.message
                  } else if (e.priority === 2) {
                    this.bannerError = res.message
                    if (window.localStorage.getItem('prevImageBannerObj')) {
                      const prevImageObj = JSON.parse(window.localStorage.getItem('prevImageBannerObj'))
                      this.imgBanner = prevImageObj.loc
                    }
                  }
                  if (document.getElementById('bannerImg')) {
                    if (!this.imgBanner) {
                      let w = document.getElementById('bannerImg').clientHeight
                      document.querySelector('#newfoundry-uploader-banner-choose').style.height = w + 'px'
                    }
                  } else if (document.getElementById('withoutBannerImg')) {
                    if (!this.imgBanner) {
                      let w = document.getElementById('withoutBannerImg').clientHeight
                      document.querySelector('#newfoundry-uploader-banner-choose').style.height = w + 'px'
                    }
                  }
                  this.isLogoImgUploadStart = false
                  this.isBannerImgUploadStart = false
                }
                this.isEditable = false
                this.bannerEditable = false
              }
            })
            .catch((err) => {
              this.imageProcessingBanner = false
              this.imageProcessingLogo = false
              this.imageProcessing = false
              if (err.response?.status == 415) {
                this.setImageLoc(e.priority)
                if (err.response.data.error.errors['validAspectRatio']) {
                  Toaster.notifyError(`${err.response.data.error.message} ${err.response.data.error.errors.validAspectRatio[0]}`)
                } else if (err.response.data.error.errors['validDimension']) {
                  Toaster.notifyError(`${err.response.data.error.message} ${err.response.data.error.errors.validDimension[0]}`)
                } else {
                  Toaster.notifyError(err.response.data.error.message)
                }
              } else if (err.response?.status == 400) {
                this.setImageLoc(e.priority)
                Toaster.notifyError(err.response.data.error)
              } else if (err.response?.status == 413) {
                this.setImageLoc(e.priority)
                Toaster.notifyError(err.response.data.error.message)
              } else {
                let errmsg = Errors.create({
                  message: err.message
                })
                this.$store.dispatch('errors/throw', errmsg)
              }
            })
      }).catch((err) => {
        this.imageProcessingBanner = false
        this.imageProcessingLogo = false
        this.imageProcessing = false
      })
    },
    getUserInitials() {
      let name = this.foundry.name.split(' ')
      let initials = name.map(e => {
        if (e[0] !== '') {
          return e[0]
        } else return ''
      }).join('').toUpperCase()
      return initials
    },
    resizeBanner() {
      if (document.querySelector('#newfoundry-uploader-banner-choose')) {
        if (window.innerWidth < 743) {
          if (document.getElementById('withoutBannerImg') && document.querySelector('.uploadImgWithoutBanner')) {
            document.querySelector('.uploadImgWithoutBanner').style.bottom = 0
          }
          document.querySelector('#newfoundry-uploader-banner-choose').style.height = '94px'
        } else if (window.innerWidth > 744 && window.innerWidth < 1024) {
          document.querySelector('#newfoundry-uploader-banner-choose').style.height = '256px'
        } else {
          document.querySelector('#newfoundry-uploader-banner-choose').style.height = '288px'
        }
      }
    },
    onCountrySearchBlur() {
      if (isEmpty(this.country.values)) {
        this.country.values = {}
        this.selectedCountry = {}
      }
      else if (this.country.values !== 'object') {
        this.country.values = {
          ...this.selectedCountry,
          iso: this.selectedCountry.value,
          name: this.selectedCountry.label
        }
      }
    },
    onStateBlur() {
      if (isEmpty(this.states.values)) {
        this.states.values = {}
        this.selectedState = {}
      }
      else if (this.states.values !== 'object') {
        this.states.values = {
          ...this.selectedState,
        }
      }
    },
    closeOtherItems(currentItem) {
      const accordionItems = [
        this.$refs.imageryAccordionItem,
        this.$refs.informationAccordionItem,
        this.$refs.diversityAccordionItem,
        this.$refs.contactInfoAccordionItem
      ];

      accordionItems.forEach((item) => {
        if (item && item !== currentItem) {
          item.openState = false;
        }
      });
    },
    closeAllAccordionsOn100Percent() {
      const accordionItems = [
        this.$refs.imageryAccordionItem,
        this.$refs.informationAccordionItem,
        this.$refs.diversityAccordionItem,
        this.$refs.contactInfoAccordionItem
      ]
      accordionItems.forEach((item) => {
        if (item) {
          item.openState = false
        }
      })
      this.activeSection = null
    },
    clickedSectionToggle(section) {
      if (this.activeSection === section) {
        this.activeSection = null
      } else {
        this.activeSection = section
      }
    },
    scrollToSection(e) {
      this.clickedSectionToggle(e)
      const sec = document.getElementById(e)
      if (sec && this.activeSection) {
        window.scrollTo({
          top: sec.offsetTop - 152,
          behavior: 'smooth'
        })
      }
    },
    ProfileCompletenessPerc() {
      let totalSectionCompleted = 0
      for (let i in this.foundryStatus) {
        if (this.foundryStatus[i]) {
          totalSectionCompleted += 1
        }
      }
      this.foundryCompletenessPerc = totalSectionCompleted * 25
      if (this.previousHealthPercentage <= this.foundryCompletenessPerc) {
        this.previousHealthPercentage = this.foundryCompletenessPerc
      }
      if (this.foundryCompletenessPerc === 100) {
        this.closeAllAccordionsOn100Percent()
      }
    },
    showToasterOnImageUpdate() {
      if (this.logoImageChanged) {
        Toaster.notifySuccess(this.$t('pages.profile.new_foundry.image_update_success'))
        this.logoImageChanged = false
        }
    },
    getPopupButtonText() {
      const data = misc.setPopupButtonText(this.$route.name)
      if(this.isSomethingRemoved){
        return this.$t('pages.profile.foundry_profile.well_done_popup.somethingRemovedBtn');
      }
      if (data === 'all_completed') {
        this.showWellDonePopup = false
        this.showGreatJobPopup = true
        return;
      }
      this.nextChallengeRoute = data.route
      if(data.route === 'edit_foundry') {
        return this.$t('components.navigation.success.congrats_popup.btn2');
      }
      return data.name;
    },
    navigateToNextChallenge() {
      if (!misc.isFoundryHaveModulePermission(this.$route.params.id, this.nextChallengeRoute)) {
        this.showWellDonePopup = false;
        this.showPermissionNeededPopup = true;
        return;
      }
      this.$router.push({ name: this.nextChallengeRoute,   params: {
          id: this.$route.params.id
        }
      })
      this.closeWellDonePopUp();
    },
    getFoundryHealthChallenges () {
      this.$store.dispatch('healthReport/getFoundryHealthChallenges', { foundryId: this.$route.params.id })
    },
    closePermissionNeededPopup() {
      this.showPermissionNeededPopup = false;
    }
  }
}
</script>

<style src="./../stylesheets/index.scss" lang="scss" module></style>
